import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'

import { getSignature } from 'utils/getSignature'

import { FileRequest, FileUrlsResponse } from './type'
import { createUploadRequest, createUploadRequestData } from './upload'

export const queryFileUrl = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    deletePublicFile: builder.mutation<boolean, { fileKey: string }>({
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const { deadline, signature } = await getSignature({
          payload: arg,
          primaryType: 'FileObject',
          url: apiPath.publicFile,
        })

        const result = await baseQuery({
          body: arg,
          headers: {
            deadline: `${deadline}`,
            signature,
          },
          method: 'DELETE',
          url: apiPath.publicFile,
        })

        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }
        return { data: result.data as boolean }
      },
    }),
    postUploadUrlPublicFile: builder.mutation<FileUrlsResponse, FileRequest>({
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const dataForUrl = createUploadRequestData(arg.dataForUrl, arg.file)
        const { deadline, signature } = await getSignature({
          payload: dataForUrl,
          primaryType: 'GetUploadUrl',
          url: apiPath.publicFile,
        })

        const url = await baseQuery({
          body: dataForUrl,
          headers: {
            deadline: `${deadline}`,
            signature,
          },
          method: 'POST',
          responseHandler: (response) => response.json(),
          url: apiPath.publicFile,
        })

        if (url.error) return { error: url.error as FetchBaseQueryError }

        const urlResponse = url.data as FileUrlsResponse

        const result = await baseQuery({
          ...createUploadRequest(urlResponse.uploadFields, arg.file),
          url: urlResponse.uploadUrl,
        })

        if (result.error) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: urlResponse }
      },
    }),
  }),
  reducerPath: 'fileUrl',
})
export const { useDeletePublicFileMutation, usePostUploadUrlPublicFileMutation } = queryFileUrl
